import { useNavigate, useSearchParams, useParams } from 'react-router-dom'
import { useCallback } from 'react'
import { Stack, Button } from '@mui/material'
import BoardView from '@components/Board/BoardView'
import { useIsMobile } from '@/hooks/Responsive' 
import { fetchMyInquiryDetail } from '@/api/mypage'
import { useAuth } from '@/components/AuthContext'

export default function MyInquiryView() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const navigate = useNavigate()
  const { isMobile } = useIsMobile() 
  const { user, loading, isAuthReady } = useAuth();

  const fetcher = useCallback(async () => {
    try {
      const response = await fetchMyInquiryDetail({ params: {bbsType: type, bulletinId: id, accountId: user.accountId } });
      const data = response.data;
      return {
        id: data.bulletinId,
        isQna: true, // API 응답에 따라 조정 필요
        qCategory: data.bbsCategoryName,
        qLecture: data.eduLectureName,
        title: data.bulletinTitle,
        createdAt: data.registDttm,
        content: data.bulletinSubstatnce,
        answer: data.commentSubstatnce,
        attachments: (data?.questionAttachFileName && data?.questionAttachFileUrl) ? [{name: data?.questionAttachFileName ,url: data?.questionAttachFileUrl}] : [], // API 응답에 따라 조정 필요{ name: '캡쳐.jpg', url: '/files/file.jpg' }
        answerattachments: (data?.answerAttachFileUrl && data?.answerAttachFileName) ? [{name: data?.answerAttachFileName ,url: data?.answerAttachFileUrl}] : [], // API 응답에 따라 조정 필요
      };
    } catch (error) {
      console.error("Failed to fetch inquiry detail:", error);
      return null; // 에러 발생 시 null 반환 또는 적절한 에러 처리
    }
  }, [id,type]);

  return (
    <BoardView
      fetcher={fetcher}
      bottomToolbarRender={() => (
        <Stack direction="row" justifyContent="flex-end">
          <Button 
            variant="contained" 
            size="large"
            sx={{ width: isMobile ? '100%' : 'auto'}} 
            onClick={() => navigate(-1)}
          >
            목록
          </Button>
        </Stack>
      )}
    />
  )
}
